module.exports = __webpack_public_path__ + "img/part2-bg6.d412d18a.png";